<template>
  <section class="sights-skeleton">
    <PageWrap>
      <SkeletonItem
        class="sights-skeleton__title"
        width="280px"
        :border-radius="8"
        :is-animated="animated"
        ignore-global-animation
      />
    </PageWrap>

    <div class="sights-skeleton__viewport">
      <div class="sights-skeleton__row">
        <div
          v-for="n in 8"
          :key="n"
          class="sights-skeleton__card"
        >
          <SkeletonItem
            width="100%"
            height="100%"
            :border-radius="8"
            :is-animated="animated"
            ignore-global-animation
          />
        </div>
      </div>
    </div>

    <!-- Место под кнопку «Смотреть все»: в реальном блоке она показывается на планшете и мобильном -->
    <PageWrap class="sights-skeleton__more-wrap">
      <SkeletonItem
        class="sights-skeleton__more"
        :border-radius="12"
        :is-animated="animated"
        ignore-global-animation
      />
    </PageWrap>
  </section>
</template>

<script setup lang="ts">
  import { SkeletonItem } from '@experience/core-skeleton-lib';

  import PageWrap from '@/shared/ui/PageWrap.vue';

  withDefaults(
    defineProps<{
      animated?: boolean;
    }>(),
    {
      animated: true,
    },
  );
</script>

<style scoped lang="scss">
  // Размеры подогнаны под реальный AttractionsSection (замерено): слайдер — один ряд, а не сетка,
  // плюс кнопка «Смотреть все» на планшете/мобильном. Так нет сдвига при замене скелетона контентом.
  .sights-skeleton {
    position: relative;
    padding: 40px 0 0;
    overflow: hidden;

    &__title {
      height: 32px;
      margin-bottom: 24px;
    }

    &__viewport {
      box-sizing: border-box;
      width: 100vw;
      min-width: var(--wrap-min-width);
      max-width: var(--wrap-max-width);
      padding: 0 var(--wrap-offset);
      margin: 0 auto;

      @include tablet {
        padding: 0 20px;
      }
    }

    &__row {
      display: flex;
      gap: 16px;
      overflow: hidden;
    }

    &__card {
      flex: none;
      width: 190px;
      height: 263px;
    }

    &__more-wrap {
      display: none;
    }

    &__more {
      width: 100%;
      height: 50px;
      margin-top: 24px;
    }

    @include tablet {
      padding: 32px 0 0;

      &__more-wrap {
        display: block;
      }
    }

    @include mobile {
      &__title {
        height: 28px;
        margin-bottom: 16px;
      }

      &__viewport {
        padding: 0 24px;
      }

      &__card {
        width: 160px;
      }

      &__more {
        margin-top: 16px;
      }
    }
  }
</style>
